// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3j-1";
export var movingGradient = "_3j-4";
export var movingGradientBlock = "_3j-2";
export var skeleton = "_3j-0";
export var skeletonText = "_3j-3";